import { render, staticRenderFns } from "./WvSteakHouseTwoColumnSection.vue?vue&type=template&id=31cea707&scoped=true"
import script from "./WvSteakHouseTwoColumnSection.vue?vue&type=script&lang=ts"
export * from "./WvSteakHouseTwoColumnSection.vue?vue&type=script&lang=ts"
import style0 from "./WvSteakHouseTwoColumnSection.vue?vue&type=style&index=0&id=31cea707&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cea707",
  null
  
)

export default component.exports